document.addEventListener('DOMContentLoaded', () => {
  setupMainCartLogic();
  setupNotificationCartLogic();
  setupDrawerCartLogic();
  observeCartDrawerChanges();
});

const setupMainCartLogic = () => {
  const checkoutButton = document.querySelector('#checkout');
  const termsCheckbox = document.querySelector('#terms-checkbox');
  const warningMessage = document.querySelector('#terms-warning');

  if (!checkoutButton || !termsCheckbox) return;

  warningMessage && (warningMessage.style.display = 'none');

  checkoutButton.addEventListener('click', function (event) {
    if (!termsCheckbox.checked) {
      event.preventDefault();
      warningMessage.style.display = 'block';
    }
  });

  termsCheckbox.addEventListener('change', function () {
    if (termsCheckbox.checked) {
      warningMessage.style.display = 'none';
    }
  });
}

const setupDrawerCartLogic = () => {
  const drawerCheckoutButton = document.querySelector('#CartDrawer-Checkout');
  const drawerTermsCheckbox = document.querySelector('#drawer-terms-checkbox');
  const drawerWarningMessage = document.querySelector('#drawer-terms-warning');

  if (!drawerCheckoutButton || !drawerTermsCheckbox) return;

  drawerWarningMessage && (drawerWarningMessage.style.display = 'none');

  drawerCheckoutButton.addEventListener('click', function (event) {
    if (!drawerTermsCheckbox.checked) {
      event.preventDefault();
      drawerWarningMessage.style.display = 'block';
    }
  });

  drawerTermsCheckbox.addEventListener('change', function () {
    if (drawerTermsCheckbox.checked) {
      drawerWarningMessage.style.display = 'none';
    }
  });
}

const setupNotificationCartLogic = () => {
  const notificationCheckoutButton = document.querySelector('#CartNotification-Checkout-Button');
  const notificationTermsCheckbox = document.querySelector('#notification-terms-checkbox');
  const notificationWarningMessage = document.querySelector('#notification-terms-warning');

  if (!notificationCheckoutButton || !notificationTermsCheckbox) return;

  notificationWarningMessage && (notificationWarningMessage.style.display = 'none');

  notificationCheckoutButton.addEventListener('click', function (event) {
    if (!notificationTermsCheckbox.checked) {
      event.preventDefault();
      notificationWarningMessage.style.display = 'block';
    }
  });

  notificationTermsCheckbox.addEventListener('change', function () {
    if (notificationTermsCheckbox.checked) {
      notificationWarningMessage.style.display = 'none';
    }
  });
}

function observeCartDrawerChanges() {
  const cartDrawer = document.querySelector('cart-drawer');

  if (!cartDrawer) return;

  const observer = new MutationObserver(() => {
    setupDrawerCartLogic();
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}
